export default "__VITE_ASSET__8567b89f__"